import React from 'react'
import { LocalCustomDateTime } from '../LocalCustomDateTime'
import { formatConstants } from '@ztechapps/common.utils'
import type { CommonDateTimeProps } from '../types/CommonDateTimeProps'

export type LocalDateProps = Omit<CommonDateTimeProps, 'format'>

export const LocalDate = ({ value, timeZone }: LocalDateProps) => {
  return <LocalCustomDateTime {...{ timeZone, value, format: formatConstants.date }} />
}
